<template>
  <div class="properties_container">
    <div
      v-for="p in properties"
      v-bind:key="p._id"
    >
      <PropertyCard v-bind:data="p"></PropertyCard>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PropertyCard from "@/components/PropertyCard.vue";

export default {
  name: "PropertyCardList",
  components: {
    PropertyCard
  },
  props: {
    properties: Array
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.properties_container {
  display: flex;
  flex-wrap: wrap;
  > div {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    @media all and (min-width: 1821px) {
      width: calc(100% / 6 - 0.01px);
    }
    @media all and (min-width: 1441px) and (max-width: 1820px) {
      width: calc(100% / 5 - 0.01px);
    }
    @media all and (min-width: 1271px) and (max-width: 1440px) {
      width: calc(100% / 4 - 0.01px);
    }
    @media all and (min-width: 901px) and (max-width: 1270px) {
      width: calc(100% / 3 - 0.01px);
    }
    @media all and (min-width: 481px) and (max-width: 900px) {
      width: calc(100% / 2 - 0.01px);
    }
    @media all and (max-width: 480px) {
      width: calc(100% / 1 - 0.01px);
    }
    box-sizing: border-box;
    padding: 8px 8px 12px 8px;
  }
}
</style>
